module.exports = __webpack_public_path__ + "static/banner-1-a2eaa78a05096d28162e8e1ca747ad0a.jpg";